import React, { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";

export default function Profile() {
  const { user, error } = useContext(UserContext);

  return (
    <div className="w-full max-w-md max-sm:max-w-sm p-4 sm:p-6 md:p-8 my-16 mx-auto rounded-md z-30 shadow-lg border border-gray-200">
      <h1 className="text-3xl font-bold text-gray-900">Profil</h1>
      {error && (
        <p className="text-red-500 bg-red-200 px-4 py-2 rounded-md">{error}</p>
      )}
      {user ? (
        <div>
          <p>
            <strong>Nom:</strong> {user.name}
          </p>
          <p>
            <strong>Email:</strong> {user.email}
          </p>
          {/* Ajoutez d'autres informations utilisateur ici */}
        </div>
      ) : (
        !error && <p>Chargement...</p>
      )}
    </div>
  );
}
